var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#425c77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "adobe-icon-svg",
    d: "M197.5,0H42.5C19,0,0,19,0,42.5v149C0,215,19,234,42.5,234h155c23.5,0,42.5-19,42.5-42.5V42.5C240,19,221,0,197.5,0ZM87.2,164.2c0,1.1-.5,1.6-1.4,1.6h-19.6c-.9,0-1.3-.5-1.3-1.6V61.2c0-.9.5-1.3,1.4-1.3h19.5c.6-.1,1.2.3,1.3,1,.1.1.1.2.1.3v103ZM176.7,160.8c-5.2,2.2-10.7,3.8-16.3,4.8-5,.9-10.2,1.4-15.4,1.4-7.4.1-14.8-1.4-21.5-4.5-6.3-2.9-11.5-7.7-15.1-13.6-3.7-6.1-5.5-13.7-5.5-22.8-.1-7.4,1.8-14.7,5.5-21.1,3.8-6.5,9.3-11.9,15.9-15.5,7-3.9,15.4-5.8,25.3-5.8.5,0,1.2,0,2.1.1.9.1,1.9.1,3.1.2v-31.6c0-.7.3-1.1,1-1.1h20.3c.5-.1.9.3,1,.7v95.4c0,1.8.1,3.8.2,6,.2,2.1.3,4.1.4,5.8,0,.7-.3,1.3-1,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adobe-icon-svg",
    d: "M148.8,102.3c-3.9,0-7.8.8-11.3,2.6-3.4,1.7-6.3,4.2-8.5,7.4-2.2,3.2-3.3,7.5-3.3,12.7-.1,3.5.5,7,1.7,10.3,1,2.7,2.5,5.1,4.5,7.1,1.9,1.8,4.2,3.2,6.8,4,2.7.9,5.5,1.3,8.3,1.3,1.5,0,2.9-.1,4.2-.2,1.3.1,2.5-.1,3.6-.5v-44c-.9-.2-1.8-.4-2.7-.5-1.1-.1-2.2-.2-3.3-.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndesignIcon);
export default __webpack_public_path__ + "static/media/indesign-icon.d2b505e23f3c9cd62d5005fdc6c37593.svg";
export { ForwardRef as ReactComponent };